import React from 'react';

const SvgIconCarOn = props => (
  <svg width={221} height={73} viewBox="0 0 221 73" {...props}>
    <defs>
      <linearGradient id="icon-car-on_svg__a" x1="49.993%" x2="49.993%" y1="-83.537%" y2="97.079%">
        <stop offset="0%" stopColor="#8E071E" />
        <stop offset="25.88%" stopColor="#80061A" />
        <stop offset="74.25%" stopColor="#5D020F" />
        <stop offset="100%" stopColor="#470008" />
      </linearGradient>
      <linearGradient id="icon-car-on_svg__b" x1="33.071%" x2="58.835%" y1="42.831%" y2="56.55%">
        <stop offset="0%" stopColor="#FE074E" />
        <stop offset="23.72%" stopColor="#F00641" />
        <stop offset="68.02%" stopColor="#CD031D" />
        <stop offset="100%" stopColor="#AF0000" />
      </linearGradient>
      <linearGradient id="icon-car-on_svg__c" x1="37.046%" x2="56.438%" y1="45.243%" y2="54.925%">
        <stop offset="0%" stopColor="#FE074E" />
        <stop offset="23.72%" stopColor="#F00641" />
        <stop offset="68.02%" stopColor="#CD031D" />
        <stop offset="100%" stopColor="#AF0000" />
      </linearGradient>
      <linearGradient id="icon-car-on_svg__d" x1="40.837%" x2="90.857%" y1="34.118%" y2="120.756%">
        <stop offset="0%" stopColor="#8E071E" />
        <stop offset="25.88%" stopColor="#80061A" />
        <stop offset="74.25%" stopColor="#5D020F" />
        <stop offset="100%" stopColor="#470008" />
      </linearGradient>
      <linearGradient id="icon-car-on_svg__e" x1="25%" x2="75.027%" y1="6.683%" y2="93.333%">
        <stop offset="0%" stopColor="#E4A8C0" />
        <stop offset="100%" stopColor="#A7496E" />
      </linearGradient>
      <linearGradient id="icon-car-on_svg__f" x1="39.36%" x2="89.381%" y1="31.557%" y2="118.195%">
        <stop offset="0%" stopColor="#8E071E" />
        <stop offset="25.88%" stopColor="#80061A" />
        <stop offset="74.25%" stopColor="#5D020F" />
        <stop offset="100%" stopColor="#470008" />
      </linearGradient>
      <linearGradient id="icon-car-on_svg__g" x1="25.002%" x2="75.03%" y1="6.683%" y2="93.333%">
        <stop offset="0%" stopColor="#E4A8C0" />
        <stop offset="100%" stopColor="#A7496E" />
      </linearGradient>
      <linearGradient id="icon-car-on_svg__h" x1="36.93%" x2="64.382%" y1="46.618%" y2="56.021%">
        <stop offset="0%" stopColor="#E4A8C0" />
        <stop offset="100%" stopColor="#A7496E" />
      </linearGradient>
      <linearGradient id="icon-car-on_svg__i" x1="35.575%" x2="63.491%" y1="46.409%" y2="56.428%">
        <stop offset="0%" stopColor="#8E071E" />
        <stop offset="25.88%" stopColor="#80061A" />
        <stop offset="74.25%" stopColor="#5D020F" />
        <stop offset="100%" stopColor="#470008" />
      </linearGradient>
      <linearGradient id="icon-car-on_svg__j" x1="49.908%" x2="49.908%" y1=".007%" y2="100.005%">
        <stop offset="0%" stopOpacity={0} />
        <stop offset="100%" />
      </linearGradient>
      <linearGradient id="icon-car-on_svg__k" x1="22.658%" x2="80.733%" y1="28.892%" y2="82.742%">
        <stop offset="0%" stopColor="#8E071E" />
        <stop offset="25.88%" stopColor="#80061A" />
        <stop offset="74.25%" stopColor="#5D020F" />
        <stop offset="100%" stopColor="#470008" />
      </linearGradient>
      <linearGradient id="icon-car-on_svg__l" x1="27.075%" x2="69.756%" y1="31.868%" y2="71.407%">
        <stop offset="0%" stopColor="#FE074E" />
        <stop offset="23.72%" stopColor="#F00641" />
        <stop offset="68.02%" stopColor="#CD031D" />
        <stop offset="100%" stopColor="#AF0000" />
      </linearGradient>
      <linearGradient id="icon-car-on_svg__m" x1="44.478%" x2="61.035%" y1="14.165%" y2="88.639%">
        <stop offset="0%" stopColor="#8E071E" />
        <stop offset="25.88%" stopColor="#80061A" />
        <stop offset="74.25%" stopColor="#5D020F" />
        <stop offset="100%" stopColor="#470008" />
      </linearGradient>
      <linearGradient id="icon-car-on_svg__n" x1="49.217%" x2="50.175%" y1="48.81%" y2="51.46%">
        <stop offset="0%" stopColor="#8E071E" />
        <stop offset="25.88%" stopColor="#80061A" />
        <stop offset="74.25%" stopColor="#5D020F" />
        <stop offset="100%" stopColor="#470008" />
      </linearGradient>
      <linearGradient id="icon-car-on_svg__o" x1="35.309%" x2="64.813%" y1="42.698%" y2="55.873%">
        <stop offset="0%" stopColor="#8E071E" />
        <stop offset="25.88%" stopColor="#80061A" />
        <stop offset="74.25%" stopColor="#5D020F" />
        <stop offset="100%" stopColor="#470008" />
      </linearGradient>
      <linearGradient id="icon-car-on_svg__p" x1="39.033%" x2="60.616%" y1="28.21%" y2="72.93%">
        <stop offset="0%" stopColor="#E4A8C0" />
        <stop offset="100%" stopColor="#A7496E" />
      </linearGradient>
      <linearGradient id="icon-car-on_svg__q" x1="22.432%" x2="65.265%" y1="33.38%" y2="70.54%">
        <stop offset="0%" stopColor="#E4A8C0" />
        <stop offset="100%" stopColor="#A7496E" />
      </linearGradient>
      <linearGradient id="icon-car-on_svg__r" x1="27.916%" x2="71.999%" y1="30.673%" y2="68.937%">
        <stop offset="0%" stopColor="#E4A8C0" />
        <stop offset="100%" stopColor="#A7496E" />
      </linearGradient>
      <linearGradient id="icon-car-on_svg__s" x1="-3.845%" x2="69.178%" y1="6.055%" y2="64.006%">
        <stop offset="0%" stopColor="#8E071E" />
        <stop offset="25.88%" stopColor="#80061A" />
        <stop offset="74.25%" stopColor="#5D020F" />
        <stop offset="100%" stopColor="#470008" />
      </linearGradient>
      <linearGradient id="icon-car-on_svg__t" x1="12.539%" x2="62.327%" y1="8.677%" y2="112.915%">
        <stop offset="0%" stopColor="#8E071E" />
        <stop offset="25.88%" stopColor="#80061A" />
        <stop offset="74.25%" stopColor="#5D020F" />
        <stop offset="100%" stopColor="#470008" />
      </linearGradient>
      <linearGradient id="icon-car-on_svg__u" x1="31.474%" x2="59.691%" y1="9.265%" y2="98.315%">
        <stop offset="0%" stopColor="#E4A8C0" />
        <stop offset="100%" stopColor="#A7496E" />
      </linearGradient>
      <linearGradient id="icon-car-on_svg__v" x1="-5.708%" x2="69.107%" y1="-21.98%" y2="74.75%">
        <stop offset="0%" stopColor="#8E071E" />
        <stop offset="25.88%" stopColor="#80061A" />
        <stop offset="74.25%" stopColor="#5D020F" />
        <stop offset="100%" stopColor="#470008" />
      </linearGradient>
      <linearGradient id="icon-car-on_svg__w" x1="32.81%" x2="98.633%" y1="41.597%" y2="77.973%">
        <stop offset="0%" stopColor="#8E071E" />
        <stop offset="25.88%" stopColor="#80061A" />
        <stop offset="74.25%" stopColor="#5D020F" />
        <stop offset="100%" stopColor="#470008" />
      </linearGradient>
      <linearGradient id="icon-car-on_svg__x" x1="-10.864%" x2="70.509%" y1="-28.73%" y2="76.479%">
        <stop offset="0%" stopColor="#8E071E" />
        <stop offset="25.88%" stopColor="#80061A" />
        <stop offset="74.25%" stopColor="#5D020F" />
        <stop offset="100%" stopColor="#470008" />
      </linearGradient>
      <linearGradient id="icon-car-on_svg__y" x1="32.861%" x2="93.871%" y1="41.581%" y2="75.305%">
        <stop offset="0%" stopColor="#8E071E" />
        <stop offset="25.88%" stopColor="#80061A" />
        <stop offset="74.25%" stopColor="#5D020F" />
        <stop offset="100%" stopColor="#470008" />
      </linearGradient>
      <linearGradient id="icon-car-on_svg__z" x1="32.795%" x2="73.295%" y1="35.044%" y2="64.426%">
        <stop offset="0%" stopColor="#E4A8C0" />
        <stop offset="100%" stopColor="#A7496E" />
      </linearGradient>
    </defs>
    <g fill="none" fillRule="evenodd">
      <g fillRule="nonzero">
        <path
          fill="url(#icon-car-on_svg__a)"
          d="M172.95 71s-7.435-.639-9.863-6.43c0 0-.579.18-1.31.26-.731.08-3.657.19-4.418.3-.772.11.233-1.098.578-1.288.346-.19-95.011-.939-95.011-.939s-2.133 5.012-7.801 5.95c-5.668.929-25.485-9.584-25.485-9.584s-1.564 1.668-3.85 1.718c-2.285.05-5.698-22.553 13.682-25.818 19.39-3.264 146.733-2.626 152.899.46 6.165 3.094 10.462 10.901 10.614 15.144.153 4.233-.863 10.523-3.687 12.31 0 0-.548.4-1.798.59-1.249.189-3.138.309-4.113.498-.996.19-20.437 6.829-20.437 6.829z"
        />
        <path
          fill="url(#icon-car-on_svg__b)"
          d="M73 2.242S68.816.816 65.249 1.02c-1.15.064-2.071.986-2.197 2.165-.02.236-.042.515-.052.815l10-1.758z"
        />
        <path
          fill="url(#icon-car-on_svg__c)"
          d="M218.095 57.875s.758-2.494.728-4.988c0 0 1.222 0 1.464-.432 0 0 2.183-11.565-1.09-15.97-3.243-4.364-21.73-10.941-50.845-13.194-.536-.04-1.071 0-1.586.12-1.081.252-3.273.674-6.031.795-.465.02-.92-.12-1.304-.382-3.364-2.363-20.83-14.43-33.852-18.725-.101-.03-.091-.171.01-.191.848-.14 2.859-.443 4.394-.493 0 0-15.618-5.068-37.166-4.344-18.093.603-26.134 1.66-36.61 4.767C45.73 7.945 31.102 14.894 28.355 16.07c-2.748 1.186-5.425 2.886-11.062 3.55-5.405.633-9.537 1.055-12.234 1.619a.482.482 0 0 0-.384.432c-.121 1.619-.576 8.538-.03 14.893.03.373-.091.745-.344 1.026-.818.895-2.717 3.027-3.92 4.888a1.755 1.755 0 0 0-.282.995c.01.704.09 2.152.474 4.747 0 0-.262.312-.484.734a.779.779 0 0 0-.071.523c.273 1.187 1.646 6.044 6.304 8.689.394.22.838.352 1.283.382 2.586.18 12.244.875 18.062 1.79l.415.06v-3.68c0-13.607 8.708-18.987 18.083-18.987h2.232c11.507 0 17.528 8.468 17.528 20.415v5.611c1.616.08 2.91.13 3.778.13 6.284 0 27.428-.311 60.401 0 19.962.192 27.903.112 32.126-.05v-7.26c0-12.36 7.718-19.168 17.234-19.168h3.394c13.022 0 17.79 10.82 17.79 20.606V62.5c.263 0 .93-.01 1.708-.06 1.02-.06 1.353-.845 4.01-1.066 2.657-.222 10.557-1.217 14.396-1.69 3.152-.392.808-1.639-.667-1.81z"
        />
        <circle cx={179} cy={57} r={16} fill="url(#icon-car-on_svg__d)" />
        <circle cx={179.5} cy={55.5} r={11.5} fill="url(#icon-car-on_svg__e)" />
        <circle cx={46} cy={57} r={16} fill="url(#icon-car-on_svg__f)" />
        <circle cx={46.5} cy={55.5} r={11.5} fill="url(#icon-car-on_svg__g)" />
        <path
          fill="url(#icon-car-on_svg__h)"
          d="M141.83 16.383c-7.28-4.275-17.713-9.272-28.696-10.937-15.67-2.377-34.848-1.747-44.67 1.33-8.227 2.57-18.935 6.814-24.985 10.684-.987.63-1.444 1.056-1.475 2.153-.01.325-.01.69.092 1.066.234.863.58 1.422 1.525 1.432 2.837.01 9.65.04 18.64.04 11.958 0 59.65.844 71.15 1.433 3.559.182 6.823.314 9.589.416-.214-2.844-.783-5.82-1.17-7.617z"
        />
        <path
          fill="url(#icon-car-on_svg__i)"
          d="M153.676 24.57c-2.578-2.255-18.098-16.357-38.724-19.713-18.352-2.985-35.712-2.11-45.247.772-8.786 2.656-20.848 7.39-27.249 11.817a3.376 3.376 0 0 0-1.425 3.232c.05.37.121.772.232 1.194.243.978 1.113 1.678 2.103 1.678 3.003.01 10.223.041 19.727.041 12.659 0 63.142.958 75.306 1.637 10.586.587 14.62.741 15.44.772a.16.16 0 0 0 .161-.154v-.556a.941.941 0 0 0-.324-.72zM94.234 4.197zm2.77.062c-.889-.03-1.769-.041-2.648-.052.88 0 1.76.021 2.649.052zm-54.83 16.83c-.102-.37-.102-.741-.092-1.08.03-1.113.486-1.545 1.466-2.183 4.813-3.13 12.578-6.506 19.676-9.069-.647.237-1.314.474-1.971.72-3.792 5.076-7.776 11.9-9.292 13.074h.718c-4.166-.01-7.29-.02-8.989-.031-.93.01-1.284-.556-1.517-1.431zm20.05 1.482c-3.095 0-5.926 0-8.433-.01h1.76c4.215-8.214 9.706-14.524 9.706-14.524-.637.216-1.285.453-1.942.69a146.99 146.99 0 0 1 5.086-1.73c5.51-1.76 13.983-2.728 23.114-2.8.697 4.622 2.588 18.807 2.588 18.807h.03c-13.508-.247-26.45-.433-31.91-.433zm-9.222-.01h.475-.475zm79.957 1.462c-5.116-.268-17.471-.587-30.616-.855h.05c-1.526-6.927-5.226-18.878-5.237-18.91 5.299.166 10.657.619 15.662 1.4 10.92 1.689 21.294 6.753 28.533 11.087.384 1.822.95 4.838 1.143 7.7-2.75-.103-5.996-.237-9.535-.422z"
        />
        <path
          fill="url(#icon-car-on_svg__j)"
          d="M7.8 62.797h-.02c-.14-.01-.25-.142-.24-.305 1.31-23.147-1.33-35.544-1.53-36.449-.49-.762-.88-2.174-.89-2.235-.01-.03-.01-.071-.01-.112.05-.63-.16-.904-.17-.914a.317.317 0 0 1-.06-.132L.77 2.286C.71 1.545.44 1.097.44 1.097A.303.303 0 0 1 .51.701C.63.61.79.651.87.782c.01.02.34.57.41 1.423l4.09 20.262c.1.152.3.548.26 1.23.07.263.42 1.462.83 2.052.02.03.04.06.04.101.03.122 2.92 12.661 1.56 36.683-.01.152-.13.264-.26.264z"
          opacity={0.5}
          transform="translate(93 2)"
        />
        <path
          fill="url(#icon-car-on_svg__k)"
          d="M146.806 22.02s1.187.175 2.005.197c.809.022 1.474 1.83 1.065 2.268-.42.45-2.64.515-3.388.515-.747 0-2.292-.11-2.415-.45-.123-.339-.184-1.83.604-2.245.778-.417 2.129-.285 2.129-.285z"
        />
        <path
          fill="url(#icon-car-on_svg__l)"
          d="M146.992 21.866c.02-.647.01-1.519-.11-2.214a1.01 1.01 0 0 0-.44-.676c-.819-.569-3.037-1.901-5.904-1.97-3.637-.088-4.067.774-4.277 1.176-.17.343-.46 2.136-.06 3.625.13.47.53.833 1.02.92 1.089.187 3.576.422 8.742.148a1.05 1.05 0 0 0 1.029-1.01z"
        />
        <path
          fill="url(#icon-car-on_svg__m)"
          d="M137.05 18.59c.099-.843.95-1.59.95-1.59-1.258.288-1.53.758-1.677 1.025-.21.374-.568 2.327-.074 3.95.16.513.653.908 1.258 1.004.037.01.074.01.11.021-1.035-.865-.665-3.566-.567-4.41z"
        />
        <path
          fill="url(#icon-car-on_svg__n)"
          d="M.61 1.587c0 .013 0 .026.01.04-.01-.014-.01-.027-.01-.04z"
          transform="translate(135 21)"
        />
        <path
          fill="url(#icon-car-on_svg__o)"
          d="M1.253 1.053c-.01 0-.021.014-.021.014.073.76.242 1.44.559 1.826 1.192.254 3.819.547 9.136.187.58-.04 1.044-.64 1.065-1.373-3.914-.694-10.74-.654-10.74-.654z"
          transform="translate(135 21)"
        />
        <path
          fill="url(#icon-car-on_svg__p)"
          d="M1.234 4.175A5.851 5.851 0 0 1 1.12 3.5c.023.237.057.475.114.675z"
          transform="translate(134 19)"
        />
        <path
          fill="url(#icon-car-on_svg__q)"
          d="M6.503 1.425C4.606.737 1.13.762 1.13.762c-.057.75-.114 1.813-.011 2.738.011 0 .023-.013.023-.013s2.937-.012 6.171.138c-.343-1.288-.811-2.2-.811-2.2z"
          transform="translate(134 19)"
        />
        <path
          fill="url(#icon-car-on_svg__r)"
          d="M127.08 5.498c-.1.02-.11.163-.01.193 12.75 4.35 29.852 16.533 33.145 18.92a2 2 0 0 0 1.276.387c2.7-.112 4.847-.549 5.906-.803.197-.05.395-.081.603-.101 0 0-18.309-12.54-36.618-19.094l-3.492.366c-.326.06-.603.101-.81.132z"
        />
        <path
          fill="url(#icon-car-on_svg__s)"
          d="M218.245 58.877s.786-2.38.754-4.761c0 0-2.493-.087-4.128-.116a4.988 4.988 0 0 0-2.305.528c-1.162.596-2.828 1.71-3.52 3.447-.178.46.178.95.713.96 1.823.058 5.783.134 8.486-.058z"
        />
        <path
          fill="url(#icon-car-on_svg__t)"
          d="M16 36.872C12.538 26.418 11.523 26.3 11.523 26.3s-.396-.275-1.36-.737c-.71-.333-1.208-1.521-1.421-2.14a1.692 1.692 0 0 0-.61-.814A4.159 4.159 0 0 0 6.844 22a44.75 44.75 0 0 0-2.162.363.475.475 0 0 0-.386.422c-.122 1.561-.568 8.1-.05 14.215C7.908 36.637 16 36.872 16 36.872z"
        />
        <path
          fill="url(#icon-car-on_svg__u)"
          d="M6.576 30.847c-.235-.716-.843-1.32-1.686-1.623A4.906 4.906 0 0 0 4.019 29c-.055 2.743 0 5.922.304 9A61.242 61.242 0 0 1 8 37.82c-.622-4.085-1.12-6.055-1.424-6.973z"
        />
        <path
          fill="url(#icon-car-on_svg__v)"
          d="M112.73 32h-2.46c-1.253 0-2.27-1.063-2.27-2.371v-.258c0-1.308 1.017-2.371 2.27-2.371h2.46c1.253 0 2.27 1.063 2.27 2.371v.258c-.01 1.308-1.017 2.371-2.27 2.371z"
        />
        <path
          fill="url(#icon-car-on_svg__w)"
          d="M116.992 30.055c-.032-.297.074-.933-1.197-1.136-1.271-.202-6.886-.919-7.966-.919h-2.13c-.381 0-.699.392-.699.892v1.15c0 .486.307.892.7.892h2.182c1.165 0 7.542.149 8.252 0 .7-.149.911-.406.858-.879z"
        />
        <path
          fill="url(#icon-car-on_svg__x)"
          d="M64.73 31h-2.46C61.016 31 60 29.937 60 28.629v-.258C60 27.063 61.017 26 62.27 26h2.46c1.253 0 2.27 1.063 2.27 2.371v.258C67 29.949 65.983 31 64.73 31z"
        />
        <path
          fill="url(#icon-car-on_svg__y)"
          d="M67.99 29.055c-.032-.297.073-.933-1.197-1.136-1.271-.216-6.885-.919-7.965-.919h-2.129c-.381 0-.699.392-.699.892v1.15c0 .486.307.892.699.892h2.182c1.165 0 7.54.149 8.25 0 .71-.162.922-.42.858-.879z"
        />
        <path
          fill="url(#icon-car-on_svg__z)"
          d="M216.978 43s.589-6.846-4.335-7.845c0 0-13.298-.191-14.06-.149-.76.043-1.735.234-1.563.936.173.712 2.883 4.539 4.71 5.166C206.075 42.596 216.978 43 216.978 43z"
        />
      </g>
      <path d="M0-21h221v94H0z" />
    </g>
  </svg>
);

export default SvgIconCarOn;
